import React, { useEffect } from "react";

function YouTubePlayer(props) {
  const videoId = props.videoId;

  useEffect(() => {
    // Load the YouTube iFrame API asynchronously
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Create the YouTube player
    let player;
    window.onYouTubeIframeAPIReady = () => {
      player = new window.YT.Player("player", {
        height: "360",
        width: "640",
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          loop: 1,
          mute: 1,
          controls: 1,
          showinfo: 0,
          modestbranding: 1,
        },
        events: {
          onReady: onPlayerReady,
        },
      });
    };

    const onPlayerReady = (event) => {
      event.target.playVideo();
    };

    return () => {
      // Clean up the player when the component unmounts
      player.destroy();
      window.onYouTubeIframeAPIReady = null;
    };
  }, [videoId]);

  return <div id="player"></div>;
}

export default YouTubePlayer;
